import React from 'react';
import { AboutSection } from '../components/AboutSection';
import { PolaGroupSection } from '../components/PolaGroupSection';
import { SolutionsSection } from '../components/SolutionsSection';
export function AboutPage() {
  return <div className="pt-28" data-id="element-483">
      <AboutSection data-id="element-484" />
      <PolaGroupSection data-id="element-485" />
      <SolutionsSection data-id="element-486" />
    </div>;
}